var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategicPlanImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.651 25.3071C14.2265 25.3071 14.6929 25.7735 14.6929 26.3489C14.6929 26.9244 14.2265 27.3908 13.651 27.3908C13.0756 27.3908 12.6092 26.9244 12.6092 26.3489C12.6092 25.7735 13.0756 25.3071 13.651 25.3071Z",
    fill: "url(#paint0_linear_0_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1163 25.3071C22.6917 25.3071 23.1582 25.7735 23.1582 26.3489C23.1582 26.9244 22.6917 27.3908 22.1163 27.3908C21.5409 27.3908 21.0744 26.9244 21.0744 26.3489C21.0744 25.7735 21.5409 25.3071 22.1163 25.3071Z",
    fill: "url(#paint1_linear_0_4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3489 21.0741C26.9244 21.0741 27.3908 21.5406 27.3908 22.116C27.3908 22.6914 26.9244 23.1579 26.3489 23.1579C25.7735 23.1579 25.3071 22.6914 25.3071 22.116C25.3071 21.5406 25.7735 21.0741 26.3489 21.0741Z",
    fill: "url(#paint2_linear_0_4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8837 16.8418C18.4591 16.8418 18.9255 17.3082 18.9255 17.8837C18.9255 18.4591 18.4591 18.9255 17.8837 18.9255C17.3082 18.9255 16.8418 18.4591 16.8418 17.8837C16.8418 17.3082 17.3082 16.8418 17.8837 16.8418Z",
    fill: "url(#paint3_linear_0_4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.651 12.6095C14.2265 12.6095 14.6929 13.0759 14.6929 13.6513C14.6929 14.2268 14.2265 14.6932 13.651 14.6932C13.0756 14.6932 12.6092 14.2268 12.6092 13.6513C12.6092 13.0759 13.0756 12.6095 13.651 12.6095Z",
    fill: "url(#paint4_linear_0_4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1163 12.6095C22.6917 12.6095 23.1582 13.0759 23.1582 13.6513C23.1582 14.2268 22.6917 14.6932 22.1163 14.6932C21.5409 14.6932 21.0744 14.2268 21.0744 13.6513C21.0744 13.0759 21.5409 12.6095 22.1163 12.6095Z",
    fill: "url(#paint5_linear_0_4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4651 11.1442C28.5687 11.1442 28.6681 11.1854 28.7414 11.2586C28.8147 11.3319 28.8558 11.4313 28.8558 11.5349V28.4651C28.8558 28.5687 28.8147 28.6681 28.7414 28.7414C28.6681 28.8147 28.5687 28.8558 28.4651 28.8558H11.5349C11.4313 28.8558 11.3319 28.8147 11.2586 28.7414C11.1854 28.6681 11.1442 28.5687 11.1442 28.4651V11.5349C11.1442 11.4313 11.1854 11.3319 11.2586 11.2586C11.3319 11.1854 11.4313 11.1442 11.5349 11.1442H28.4651ZM11.9256 28.0744H15.3767V24.6233H11.9256V28.0744ZM16.1581 28.0744H19.6093V24.6233H16.1581V28.0744ZM20.3907 28.0744H23.8419V24.6233H20.3907V28.0744ZM24.6233 28.0744H28.0744V24.6233H24.6233V28.0744ZM11.9256 23.8419H15.3767V20.3907H11.9256V23.8419ZM16.1581 23.8419H19.6093V20.3907H16.1581V23.8419ZM20.3907 23.8419H23.8419V20.3907H20.3907V23.8419ZM24.6233 23.8419H28.0744V20.3907H24.6233V23.8419ZM11.9256 19.6093H15.3767V16.1581H11.9256V19.6093ZM16.1581 19.6093H19.6093V16.1581H16.1581V19.6093ZM20.3907 19.6093H23.8419V16.1581H20.3907V19.6093ZM24.6233 19.6093H28.0744V16.1581H24.6233V19.6093ZM11.9256 15.3767H15.3767V11.9256H11.9256V15.3767ZM16.1581 15.3767H19.6093V11.9256H16.1581V15.3767ZM20.3907 15.3767H23.8419V11.9256H20.3907V15.3767ZM24.6233 15.3767H28.0744V11.9256H24.6233V15.3767Z",
    fill: "url(#paint6_linear_0_4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4386 9.19142C30.5386 9.19657 30.6328 9.23993 30.7018 9.31254C30.7708 9.38515 30.8092 9.48146 30.8092 9.58159V30.4188C30.8092 30.5224 30.768 30.6218 30.6948 30.6951C30.6215 30.7683 30.5221 30.8095 30.4185 30.8095H9.5813C9.47768 30.8095 9.3783 30.7683 9.30503 30.6951C9.23176 30.6218 9.1906 30.5224 9.1906 30.4188V9.58159C9.1906 9.47798 9.23176 9.3786 9.30503 9.30533C9.3783 9.23206 9.47768 9.1909 9.5813 9.1909H30.4185L30.4386 9.19142ZM9.97199 30.0281H30.0278V9.97229H9.97199V30.0281Z",
    fill: "url(#paint7_linear_0_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 16.2625,
    y1: 13.9917,
    x2: 27.7996,
    y2: 26.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 16.2627,
    y1: 13.9917,
    x2: 27.7997,
    y2: 26.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_4",
    x1: 16.2627,
    y1: 13.9914,
    x2: 27.7998,
    y2: 26.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_4",
    x1: 16.2626,
    y1: 13.9916,
    x2: 27.7996,
    y2: 26.9867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_4",
    x1: 16.2625,
    y1: 13.9918,
    x2: 27.7996,
    y2: 26.9869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_4",
    x1: 16.2627,
    y1: 13.9918,
    x2: 27.7997,
    y2: 26.9869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_4",
    x1: 16.2627,
    y1: 13.9917,
    x2: 27.7997,
    y2: 26.9867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_4",
    x1: 16.2626,
    y1: 13.9919,
    x2: 27.7996,
    y2: 26.9869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicPlanImg);
export default __webpack_public_path__ + "static/media/strategic-plan-img.9ff827aaf2d934c2a813e2f6a65a9513.svg";
export { ForwardRef as ReactComponent };